import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const FiltersIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.82"
        height="20.82"
        viewBox="0 0 20.82 20.82"
        className={className}
        fill="none"
        stroke="currentColor"
    >
        <line x1="5.79" y1="18.07" x2="5.79" y2="20.81" strokeMiterlimit="10" strokeWidth="2.65" />
        <line x1="5.79" x2="5.79" y2="11.18" strokeMiterlimit="10" strokeWidth="2.65" />
        <line x1="14.95" y1="9.37" x2="14.95" y2="20.81" strokeMiterlimit="10" strokeWidth="2.65" />
        <line x1="14.95" x2="14.95" y2="2.4" strokeMiterlimit="10" strokeWidth="2.65" />
        <circle cx="5.82" cy="14.62" r="3.44" strokeMiterlimit="10" strokeWidth="2.65" />
        <circle cx="15" cy="5.93" r="3.44" strokeMiterlimit="10" strokeWidth="2.65" />
    </svg>
);

FiltersIcon.propTypes = propTypes;
FiltersIcon.defaultProps = defaultProps;

export default FiltersIcon;
